import { createPublicClient, http } from 'viem'
import { mainnet, polygon, bsc, optimism, arbitrum, goerli, sepolia, polygonMumbai, bscTestnet } from 'viem/chains'

const ethClient = createPublicClient({ 
  chain: mainnet,
  transport: http()
})
const maticClient = createPublicClient({ 
  chain: polygon,
  transport: http()
})
const bscClient = createPublicClient({ 
  chain: bsc,
  transport: http()
})
const optClient = createPublicClient({ 
  chain: optimism,
  transport: http()
})
const arbClient = createPublicClient({ 
  chain: arbitrum,
  transport: http()
})
const goerliClient = createPublicClient({ 
  chain: goerli,
  transport: http()
})
const sepoliaClient = createPublicClient({ 
  chain: sepolia,
  transport: http()
})
const updatedPolygonMumbai = {
  ...polygonMumbai,
  rpcUrls: {
    ...polygonMumbai.rpcUrls,
    public: {
      http: ["https://endpoints.omniatech.io/v1/matic/mumbai/public"]
    },
    default: {
      http: ["https://endpoints.omniatech.io/v1/matic/mumbai/public"]
    }
  }
};

const mumbaiClient = createPublicClient({ 
  chain: updatedPolygonMumbai,
  transport: http()
})
const bscTestClient = createPublicClient({ 
  chain: bscTestnet,
  transport: http()
})

export interface BlockchainData {
    collectionAddress: string;
    bridgeAddress:string;
    tokenAddress: string;
    chain: 'ethereum' | 'polygon' | 'binance' | 'optimism' | 'arbitrum' | 'goerli' | 'sepolia' | 'mumbai'|'bsc-testnet';
    lightIconUrl:string;
    darkIconUrl:string;
    chainId:number;
    currency:string;
    client:any;
  }
  //ethereum, binance, polygon, arbitrum, optimism, sepolia, goerli
  export const ProdChains: BlockchainData[] = [
    {
      collectionAddress: "0x11E4C3823B7a5C6A00f193812a68c11961ddeBF3",
      bridgeAddress: "0x2c44eDF0ECf4FB27EbFCD30B58e5af4e4C9AF8C4",
      tokenAddress: "0xca0F4F6df22E0D0c1e1Cd32818870f457D28f954",
      chain: "ethereum",
      lightIconUrl: '/icons/eth-icon-dark.svg',
      darkIconUrl: '/icons/eth-icon-light.svg',
      chainId:1,
      currency:"ETH",
      client:ethClient
    },
    {
      collectionAddress: "0x34d559752B6944F0d85C075d7C2cD61BbD202A42",
      bridgeAddress: "0x2c44eDF0ECf4FB27EbFCD30B58e5af4e4C9AF8C4",
      tokenAddress: "0xca0F4F6df22E0D0c1e1Cd32818870f457D28f954",
      chain: "polygon",
      lightIconUrl: '/icons/polygon-icon-dark.svg',
      darkIconUrl: '/icons/polygon-icon-light.svg',
      chainId:137,
      currency:"MATIC",
      client:maticClient
    },
    {
      collectionAddress: "0x11E4C3823B7a5C6A00f193812a68c11961ddeBF3",
      bridgeAddress: "0x2c44eDF0ECf4FB27EbFCD30B58e5af4e4C9AF8C4",
      tokenAddress: "0xca0F4F6df22E0D0c1e1Cd32818870f457D28f954",
      chain: "binance",
      lightIconUrl: '/icons/bsc-icon-dark.svg',
      darkIconUrl: '/icons/bsc-icon-light.svg',
      chainId:56,
      currency:"BSC",
      client:bscClient
    },
  ];
  export const DevChains: BlockchainData[] = [
    {
      collectionAddress: "0x7EF3AAcCbF8503D9773aE7126FE946fa7d963A0B",
      bridgeAddress: "0x2c44eDF0ECf4FB27EbFCD30B58e5af4e4C9AF8C4",
      tokenAddress: "0xca0F4F6df22E0D0c1e1Cd32818870f457D28f954",
      chain: "sepolia",
      lightIconUrl: '/icons/goerli-icon-dark.svg',
      darkIconUrl: '/icons/goerli-icon-light.svg',
      chainId:11155111,
      currency:"ETH",
      client:sepoliaClient
    },
    {
      collectionAddress: "0x96A9B5A5B2B85CFeB8E9bB6C8Fe30e064889E2E8",
      bridgeAddress: "0x3F5Ec20371804e8FE471C8152A8710e1c25195D5",
      tokenAddress: "0xc881185911a21C91F2793804781c2B18b6E36674",
      chain: "mumbai",
      lightIconUrl: '/icons/polygon-icon-dark.svg',
      darkIconUrl: '/icons/polygon-icon-light.svg',
      chainId:80001,
      currency:"MATIC",
      client:mumbaiClient
    },
    {
      collectionAddress: "0x96A9B5A5B2B85CFeB8E9bB6C8Fe30e064889E2E8",
      bridgeAddress: "0xbb2C5A622e30432295dEE9D9a5AD5bd9aFF0e94A",
      tokenAddress: "0xCFCDf3cb225f2cbda194F087776D1E40aE64176A",
      chain: "bsc-testnet",
      lightIconUrl: '/icons/bsc-icon-dark.svg',
      darkIconUrl: '/icons/bsc-icon-light.svg',
      chainId:97,
      currency:"BNBT",
      client:bscTestClient
    },
  ];
  
  const isProduction = process.env.NEXT_PUBLIC_NODE_ENV === "production";
  export const blockchainData = isProduction ? ProdChains as BlockchainData[] : DevChains as BlockchainData[];
  /*export const blockchainData: BlockchainData[] = [
    {
      collectionAddress: "0x7EF3AAcCbF8503D9773aE7126FE946fa7d963A0B",
      bridgeAddress: "0x2c44eDF0ECf4FB27EbFCD30B58e5af4e4C9AF8C4",
      tokenAddress: "0xca0F4F6df22E0D0c1e1Cd32818870f457D28f954",
      chain: "sepolia",
      lightIconUrl: '/icons/goerli-icon-dark.svg',
      darkIconUrl: '/icons/goerli-icon-light.svg',
      chainId:11155111,
      currency:"ETH",
      client:sepoliaClient
    },
    {
      collectionAddress: "0x96A9B5A5B2B85CFeB8E9bB6C8Fe30e064889E2E8",
      bridgeAddress: "0x3F5Ec20371804e8FE471C8152A8710e1c25195D5",
      tokenAddress: "0xc881185911a21C91F2793804781c2B18b6E36674",
      chain: "mumbai",
      lightIconUrl: '/icons/polygon-icon-dark.svg',
      darkIconUrl: '/icons/polygon-icon-light.svg',
      chainId:80001,
      currency:"MATIC",
      client:mumbaiClient
    },
    {
      collectionAddress: "0x96A9B5A5B2B85CFeB8E9bB6C8Fe30e064889E2E8",
      bridgeAddress: "0xbb2C5A622e30432295dEE9D9a5AD5bd9aFF0e94A",
      tokenAddress: "0xCFCDf3cb225f2cbda194F087776D1E40aE64176A",
      chain: "bsc-testnet",
      lightIconUrl: '/icons/bsc-icon-dark.svg',
      darkIconUrl: '/icons/bsc-icon-light.svg',
      chainId:97,
      currency:"BNBT",
      client:bscTestClient
    },
  ];*/